import { getThemeForKey, NumberUtil } from "@mcleod/core";
import { Label } from "../../../label/Label";
import { LabelProps } from "../../../label/LabelProps";
import { Table } from "../../Table";

export class RowCountLabel extends Label {
    static readonly themeObjectRowCount = getThemeForKey("label.rowCount") ?? {};
    protected readonly table: Table;
    public countSupplier?: (table: Table) => number;
    public textSupplier?: (table: Table) => string | null;


    constructor(table: Table, props?: Partial<LabelProps>) {
        super();
        this.applyTheme(RowCountLabel.themeObjectRowCount, true);
        this.setProps(props);
        this.table = table;
    }

    refresh() {
        this.text = this.getDisplayText();
    }

    private getDisplayText(): string {
        if (this._designer != null) {
            return "0 Results";
        }

        const suppliedText = this.textSupplier?.(this.table);
        if (suppliedText != null){
            return suppliedText;
        }

        const suppliedCount = this.countSupplier?.(this.table);
        const count = suppliedCount ?? this.table.filteredRows?.length ?? 0;
        if (count === 1) {
            return "1 Result";
        }

        return `${NumberUtil.numberWithCommas(count)} Results`;
    }
}
